// import { ApolloLink } from "apollo-link";
// import { ApolloClient } from "apollo-client";
// import { InMemoryCache } from "apollo-cache-inmemory";
// import { HttpLink } from "apollo-link-http";
//
// const client = new ApolloClient({
//   link: new HttpLink({ uri: "/emr/query" }),
//   cache: new InMemoryCache()
// });
//
// export default client;

import axios from "axios";
import { getEMRTokenJWT } from "./sessionStorage";

export function authenticatedKickJSONClient() {
  const defaultOptions = {
    // mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  return authenticatedKickClient(defaultOptions);
}
export function authenticatedKickClient(defaultOptions) {
  var headers = defaultOptions ? defaultOptions.headers : {};

  if (getEMRTokenJWT()) {
    headers = {
      ...headers,
      Authorization: "Bearer " + getEMRTokenJWT(),
    };
  }

  return axios.create({
    baseURL: "/emr/",
    timeout: 60000,
    headers: headers,
  });
}
